import React from 'react'
import { Flex, Text, useAppTheme } from '@workwhile/ui'
import { CopyableLink } from 'components/Shared/CopyableLink'
import {
  UserPaymentEventSubType,
  UserPaymentEventType,
  UserPaymentStatus,
} from 'api/payments/getUserPayments'
import { toTitleCase } from 'lib/string'
import { AmountRender } from './AmountRender'
import { BundledPaymentDetails } from './BundledPaymentDetails'

export type PaymentWorkSummaryProps = {
  id: number
  amount: number
  eventType: UserPaymentEventType
  eventSubType?: UserPaymentEventSubType | null
  status: UserPaymentStatus
  shiftId?: number | null
  shiftStartsAt?: string | null
  shiftEndsAt?: string | null
  positionId?: number | null
  positionName?: string | null
  companyId?: number | null
  companyName?: string | null
}

export const PaymentWorkSummary = ({
  id,
  amount,
  eventType,
  shiftId,
  ...details
}: PaymentWorkSummaryProps) => {
  const { space } = useAppTheme()

  return (
    <Flex flexDirection="column" style={{ gap: space[2] }}>
      <Text fontSize="sm" fontWeight="bold">
        <CopyableLink
          label={`#${id}`}
          link={`/user_payments?payment-id=${id}`}
        />
        {' · '}
        {toTitleCase(eventType)}
        {shiftId ? (
          <>
            {' · '}
            Shift{' '}
            <CopyableLink label={`#${shiftId}`} link={`/shifts/${shiftId}`} />
          </>
        ) : null}
        {' · '}
        <AmountRender value={amount} />
      </Text>
      <BundledPaymentDetails
        eventType={eventType}
        shiftId={shiftId}
        {...details}
      />
    </Flex>
  )
}
